import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        FetchConstants({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/constants`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchConstants: ${error.message}`));
            });
        },
        FetchStudentByKeycloakID({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/students/student/keycloak-id`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchStudentByKeycloakID: ${error.message}`));
            });
        },
        FetchStudentContactDetailsByStudentID({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/students/student/contact-details/student-id/${obj.StudentID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchStudentContactByStudentID: ${error.message}`));
            });
        },
        FetchCurrentApplicantCoursesByStudentID({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/applicants/courses/current/student-id/${obj.StudentID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchCurrentApplicantCoursesByStudentID: ${error.message}`));
            });
        },
        FetchCurrentStudentEnrolmentsByStudentID({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/students/enrolments/current/student-id/${obj.StudentID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchCurrentStudentEnrolmentsByStudentID: ${error.message}`));
            });
        },
        FetchNationalities({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/nationalities`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchNationalities: ${error.message}`));
            });
        },
        FetchCountries({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/countries`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchCountries: ${error.message}`));
            });
        },
        FetchMaritalStatuses({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/marital-statuses`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchMaritalStatuses: ${error.message}`));
            });
        },
        FetchGenders({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/genders`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchGenders: ${error.message}`));
            });
        },
        FetchTitles({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/titles`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchTitles: ${error.response.data || error.message}`));
            });
        },
    },
}
function CoalesceJSON(object, returnObject) {
    if (object == null || object == '') return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};
